module.exports = __webpack_public_path__ + "img/product-atomizer-kangertech-Unibar.71bdd782.jpg";